import styled from 'styled-components';

import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceXXL } from '@xing-com/tokens';

const FullSizeIframe = styled.iframe`
  border: none;
  @media ${mediaSmallOrTiny} {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
  }
  @media ${mediaConfined} {
    width: 600px;
    height: 560px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: 'center';
`;

const IntroScreenContainer = styled.div`
  padding: ${spaceXXL};
  text-align: center;
`;

export default { FullSizeIframe, ButtonContainer, IntroScreenContainer };
